import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProjectCloudResourcesSection } from "./ProjectCloudResourcesSection";
import { StreamFeedsAndSignals } from "./StreamFeedsAndSignals";
import { StreamTakerList } from "./StreamTakerList";
import { useAuth } from "@/hooks/useAuth";

interface ProjectStreamsTabProps {
  projectId: string;
}

export const ProjectStreamsTab = ({ projectId }: ProjectStreamsTabProps) => {
  const { isEmployee } = useAuth();
  return (
    <Tabs defaultValue="feeds" className="space-y-4">
      <TabsList>
        <TabsTrigger value="feeds">Feeds &amp; Signals</TabsTrigger>
        {isEmployee && <TabsTrigger value="cloud">Cloud Resources</TabsTrigger>}
      </TabsList>

      <TabsContent value="feeds" className="space-y-8">
        <StreamFeedsAndSignals projectId={projectId} />
        <StreamTakerList projectId={projectId} />
      </TabsContent>

      {/* AWS media control is employee-only (API: requireEmployee). */}
      {isEmployee && (
        <TabsContent value="cloud">
          <ProjectCloudResourcesSection projectId={projectId} />
        </TabsContent>
      )}
    </Tabs>
  );
};
